import { TEXT_PROPS } from './default-props';

// Mood Board Color
export const BG_PRIMARY = 'rgba(255, 255, 255, 0.67)';
export const BG_SECONDARY = '#cfaa64';
export const BG_ALTERNATIVE = 'rgba(243,229,228,.61)';
export const BG_LAYER = BG_PRIMARY;
// Text Color
export const TEXT_PRIMARY = '#696b4e';
export const TEXT_SECONDARY = '#daae37';
export const TEXT_ALTERNATIVE = '#fff7ed';
export const TEXT_BUTTON = '#FFF';

export const ASSET_COLOR = '#efcad8';

// Music & Navigation Color
export const NAVIGATION_COLOR = 'rgba(129, 129, 99, 0.9)';
export const ICON_NAVIGATION_COLOR = 'white';

// Default Button Color
export const BUTTON_PROPS = {
  _hover: { opacity: '.8' },
};

export const BUTTON_PADDING_PROPS = {
  ...TEXT_PROPS.body,
  fontFamily: 'body_lv2',
  fontSize: '16px',
  variant: 'solid',
  padding: '18px 22px',
  borderRadius: '18px',
  background: 'linear-gradient(to right, #939472, #c7c4a0)',
  color: TEXT_ALTERNATIVE,
  size: 'sm',
  boxShadow: 'sm',
  position: 'relative',
  fontStyle: 'normal',
  zIndex: '20',
  minWidth: '120px',
  _hover: {
    opacity: '.7',
  },
};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'normal',
};
